module.exports = __webpack_public_path__ + "media/application/images/svgs/life-buoy-bb2305fcf58eb0e85d522053eaa2d28f.svg";